import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  size?: "sm" | "md" | "lg";
}

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}: Props) {
  const base =
    "inline-flex items-center justify-center rounded-lg border-2 font-bold transition-colors select-none touch-manipulation";
  const variants = {
    primary: "border-black bg-white text-black active:bg-gray-100",
    secondary: "border-gray-400 bg-white text-gray-600 active:bg-gray-50",
    danger: "border-red-600 bg-white text-red-600 active:bg-red-50",
  };
  const sizes = {
    sm: "min-h-[36px] px-3 py-1 text-sm",
    md: "min-h-[44px] px-4 py-2 text-base",
    lg: "min-h-[56px] px-6 py-3 text-lg",
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
